import { render, staticRenderFns } from "./CurrentPricingModal.vue?vue&type=template&id=0e4e8730"
import script from "./CurrentPricingModal.vue?vue&type=script&lang=js"
export * from "./CurrentPricingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports